import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useNavigate } from 'react-router-dom';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Text } from "@/components/ui/typography";
import { cn } from "@/lib/utils";

const TestTable = ({ className = "" }) => {
  const [tests, setTests] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTests = async () => {
      try {
        setLoading(true);
        const response = await fetch(`/api/recent-tests`);
        if (!response.ok) {
          throw new Error("Failed to fetch tests");
        }
        const data = await response.json();
        setTests(data);
      } catch (error) {
        console.error("Error fetching tests:", error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchTests();
  }, []);

  const handleClick = (test_id) => {
    navigate(`/results?test_id=${test_id}`);
  };

  if (loading) {
    return (
      <div className="text-center text-lg p-8">
        <Text>Loading...</Text>
      </div>
    );
  }

  if (tests.length === 0) {
    return (
      <div className="text-center text-lg p-8">
        <Text>No recent tests found.</Text>
      </div>
    );
  }

  return (
    <div className={cn("relative w-full max-w-[1200px] mx-auto bg-card border border-border rounded-2xl overflow-hidden", className)}>
      <Table>
        <TableHeader>
          <TableRow className="bg-muted">
            <TableHead className="text-center">Test ID</TableHead>
            <TableHead className="text-center">Topic</TableHead>
            <TableHead className="text-center">Difficulty</TableHead>
            <TableHead className="text-center">Scheduled Time</TableHead>
            <TableHead className="text-center">Action</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {tests.map((test, index) => (
            <TableRow 
              key={index} 
              className={cn(
                index % 2 === 0 ? "bg-muted/50" : "bg-background"
              )}
            >
              <TableCell className="text-center">{test.overall_test_id}</TableCell>
              <TableCell className="text-center">{test.topic}</TableCell>
              <TableCell className="text-center">{test.difficulty}</TableCell>
              <TableCell className="text-center">
                {new Date(test.scheduled_time).toLocaleString()}
              </TableCell>
              <TableCell className="text-center">
                <Button
                  variant="default"
                  size="sm"
                  onClick={() => handleClick(test.overall_test_id)}
                >
                  View Result
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

TestTable.propTypes = {
  className: PropTypes.string,
  employerEmail: PropTypes.string.isRequired,
};

export default TestTable;
